import { REMAINING_ITEMS_MESSAGES } from '../../../modernization-common/side-panel-m4/types';
export const getRemainingItemsMessage = pendingStatus => {
  if (pendingStatus.dynamicAttributesPending && pendingStatus.staticAttributesPending) {
    return REMAINING_ITEMS_MESSAGES.ATTRIBUTES_PENDING;
  }
  if (pendingStatus.dynamicQuestionnairePending) {
    return REMAINING_ITEMS_MESSAGES.DYNAMIC_ATTRIBUTES_PENDING;
  }
  if (pendingStatus.staticQuestionnairePending) {
    return REMAINING_ITEMS_MESSAGES.STATIC_ATTRIBUTES_PENDING;
  }
  return '';
};